import { Space, Typography } from "antd";
const { Title } = Typography;

const ContentHeader = (props) => {
  const { icon, title, children } = props;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "20px",
      }}
    >
      <Title level={2} style={{ margin: "0px 0px 0px 0px" }}>
        {icon && <span style={{ marginRight: "8px" }}>{icon}</span>}
        {title}
      </Title>

      <Space wrap style={{ margin: "0px" }}>
        {children}
      </Space>
    </div>
  );
};

export default ContentHeader;
